<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="dark-grey">
                <v-toolbar-title>Login Berkat Motor</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form ref="form" @submit.prevent="login()">
                  <v-text-field
                    v-model="credentials.name"
                    name="username"
                    label="Username"
                    type="text"
                    placeholder="username"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="credentials.password"
                    name="password"
                    label="Password"
                    type="password"
                    placeholder="password"
                    required
                  ></v-text-field>
                  <v-btn
                    type="submit"
                    class="mt-4"
                    color="dark-grey"
                    value="log in"
                    >Login</v-btn
                  >
                </form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import api from "@/services/http";

export default {
  name: "Login",
  data: () => ({
    
    credentials: {
      name: "",
      password: "",
    },
  }),
  created() {
    document.title ="Berkat Motor";
  },
  methods: {
    login() {
      // const { username } = this;
      // console.log(username + "logged in")
      // this.$router.replace({ name: "ViewBarang", params:{ username: username} });
      api
        .post("/login", this.credentials)
        .then((res) => {
          //console.log(res.data)
          const token = res.data.token;
          localStorage.nama = this.credentials.name;
          localStorage.token = res.data.token;

          if (token) {
            this.$router.push({
              name: "home",
              params: {
                token: token,
                nama: this.credentials.name,
              },
            });
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 500") {
            alert("koneksi database bermasalah");
          } else {
             alert("nama atau password salah");
             alert(err);
          }
        });
    },
  },
//   mounted: {
//      if( localStorage.nama) {
//         this.name = localStorage.nama;
//      }
//      if(localStorage.token) {
//         this.token = localStorage.token;
//      }
     
//   }
};
</script>